import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useOfferings = (coachActivityId) => {
  const urlStr = `${getApiUrl()}/offering?coachActivityId=${coachActivityId}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const response = await axios.get(url);
        return response.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};
